<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>BigHeadline:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"><i class="bi bi-trash-fill remove-block-icon"></i></a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text [maxLength]="500" [type]="'content'" (handleOnChange)="onChange($event, 'Heading')"
            [blockData]="block.variables?.Heading ?? ''" [placeholder]="headingPlaceholder"
            variable="Heading"></app-block-text>
        </div>
      </div>
    </div>
    <div class="right-side-container" [id]="block.blockId" (click)="onContainerClick($event)">
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div class="col-12" [innerHTML]="$safeNavigationMigration(block.variables?.Heading)"></div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification [notifications]="block.notifications" [blockId]="block.blockId"></app-notification>
    </div>
  </div>
</main>